import { render, staticRenderFns } from "./FormSubmissionRow.vue?vue&type=template&id=13ad930f&"
import script from "./FormSubmissionRow.vue?vue&type=script&lang=js&"
export * from "./FormSubmissionRow.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmissionRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports